import React, { Fragment } from "react";
import { Seo, Breadcrumb, ScrollTopBtn } from "../components";
import { HeaderThree, ServiceSingle, FooterTwo } from "../containers";

const serviceContent = {
  topImage: "/images/service/sr-d-1-1.jpg",
  heading: "IT Support & Maintenance",
  description: `Our IT Support & Maintenance services ensure that your technology infrastructure runs smoothly and efficiently. We provide proactive monitoring, regular updates, and fast issue resolution to minimize downtime and keep your systems secure. Whether it's server maintenance, user support, or network troubleshooting, our team is available to keep your operations running without interruption.`,

  middleImage: "/images/service/sr-d-1-2.jpg",
  features: [
    "24/7 Monitoring and Technical Support",
    "System Updates and Patch Management",
    "Hardware and Software Troubleshooting",
    "Preventive Maintenance and Performance Tuning",
  ],

  challengeHeading: "Challenges in IT Support & Maintenance",
  challengeParagraphs: [
    `Organizations often face challenges in maintaining reliable IT infrastructure due to evolving threats, outdated systems, and lack of real-time support. These issues can cause unexpected downtimes and productivity loss.`,
    `We address these challenges by offering proactive support, regular maintenance schedules, and prompt issue resolution, ensuring business continuity and operational efficiency.`,
  ],

  bottomImages: [
    "/images/service/sr-d-1-3.jpg",
    "/images/service/sr-d-1-4.jpg",
  ],
};

const ITSupportMaintenance = () => (
  <Fragment>
    <Seo
      title="IT Support & Maintenance Services - Tech Ayukta"
      description="Tech Ayukta offers reliable IT support and maintenance services to ensure smooth operations, minimize downtime, and keep your business systems secure and efficient."
      keywords="IT Support, IT Maintenance, System Monitoring, Technical Support, Tech Ayukta"
      canonical="https://www.techayukta.com/services/it-support-maintenance"
    />

    <HeaderThree />
    <Breadcrumb
      pageName="IT Support & Maintenance"
      bgImage="/images/breadcumb/breadcumb-bg.jpg"
    />
    <ServiceSingle
      className="space-top space-extra-bottom"
      serviceContent={serviceContent}
    />
    <FooterTwo />
    <ScrollTopBtn />
  </Fragment>
);

export default ITSupportMaintenance;
